import * as React from 'react';

const preventDefault = (event) => event.preventDefault();

const wrapPrevent = (callback) => {
  return (event) => {
    event.preventDefault();
    callback();
  }
}

class StyleButton extends React.Component {

  constructor(props) {
    super(props);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  // register with store updates to ensure rerender
  componentDidMount() {
    this.props.bindToState(this);
  }

  componentWillUnmount() {
    this.props.bindToState(this, true);
  }

  render() {
    const { store, inlineStyle, label, children } = this.props;
    const toggleInlineStyle = store.toggleInlineStyle.bind(store, inlineStyle);
    let isActive = undefined;

    if (store.getEditorState) {
      const currentStyle = store.getEditorState().getCurrentInlineStyle();
      isActive = currentStyle.has(inlineStyle);
    } else {
      // editor not yet available / initialized
      isActive = false;
    }

    if (children && typeof children == 'object') {
      const ChildInput = React.cloneElement(children, {
        toggleInlineStyle: wrapPrevent(toggleInlineStyle),
        isActive,
        label,
        inlineStyle,
        onMouseDown: preventDefault
      });

      return ChildInput;
    }

    const spanStyle = {
      fontWeight: isActive ? 'bold' : 'normal',
      color: isActive ? '#000' : '#4D4D4D',
      cursor: 'pointer',
      display: 'inline-block',
      marginRight: '1em'
    }

    return (
      <button
        aria-pressed={isActive}
        className="interactive-wrapper focus-on-light"
        onClick={wrapPrevent(toggleInlineStyle)}
        onMouseDown={preventDefault}
        style={spanStyle}
        type="button"
      >
        {label}
      </button>
    );
  }
}

export default StyleButton;
